"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _Icon = _interopRequireDefault(require("./Icon"));
var _store = require("../@api/store");
var _Chip = _interopRequireDefault(require("./Chip"));
var _excluded = ["user", "onClick", "updateParent"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var UserCard = _react["default"].forwardRef(function (_ref, ref) {
  var user = _ref.user,
    onClick = _ref.onClick,
    updateParent = _ref.updateParent,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useState = (0, _react.useState)({}),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var appcenterStore = _store.store.getState().appcenter;
  var isActive = (user.active || '').indexOf(user.companies[0]) > -1 || rest.currentCompany && (user.active || '').indexOf(rest.currentCompany.uid) > -1;
  var userGroups = [];
  var permissions = {};
  (user.groups || []).map(function (groupID) {
    var group = (rest.groups || appcenterStore.groups).find(function (g) {
      if (g.uid === groupID) return g;
      return false;
    });
    if (group) {
      userGroups.push(group);
    }
  });
  var isCompanyActive = function isCompanyActive(app) {
    return !!user.applications[app] && (!!user.applications[app].companies[appcenterStore.company.uid] || rest.currentCompany && !!user.applications[app].companies[rest.currentCompany.uid]);
  };
  var photoSize = 45;
  var userInitials = (0, _react.useMemo)(function () {
    var fullName = "".concat(user.firstName, " ").concat(user.lastName).trim().replace(/\s+/g, " ");
    var initials = fullName.split(" ").map(function (name) {
      return name[0];
    });
    initials = [initials[0], initials[initials.length - 1]];
    return initials.join("");
  }, [user]);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, rest, {
    ref: ref,
    className: "user-card  ".concat(onClick ? 'clickable' : '', " ").concat(isActive ? 'active' : 'inactive', " ").concat(user.selected ? 'selected' : ''),
    onClick: onClick
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "header"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "avatar",
    onClick: function onClick(e) {
      user.selected = !user.selected;
      e.preventDefault();
      if (typeof updateParent === 'function') {
        updateParent();
      } else {
        setState({});
      }
    }
  }, user.selected ? /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "faCheck"
  }) : /*#__PURE__*/_react["default"].createElement(_material.Avatar, {
    src: user.photo,
    alt: "Foto de perfil",
    style: {
      width: photoSize,
      height: photoSize,
      fontSize: 19
    }
  }, userInitials)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "user-info"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "user-name"
  }, user.firstName, " ", user.lastName), /*#__PURE__*/_react["default"].createElement("div", {
    className: "user-info email"
  }, user.user), /*#__PURE__*/_react["default"].createElement("div", {
    className: "user-info phone"
  }, user.phoneArea, user.phone))), isActive && !!user.applications && !!user.uid && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("h3", null, "Aplica\xE7\xF5es que pode acessar"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "chips"
  }, isCompanyActive('autodocs') && /*#__PURE__*/_react["default"].createElement(_Chip["default"], {
    avatar: "E",
    text: "EditFy",
    color: "teal"
  }), isCompanyActive('collectame') && /*#__PURE__*/_react["default"].createElement(_Chip["default"], {
    avatar: "Y",
    text: "Yopen",
    color: "orange"
  }), isCompanyActive('dokia') && /*#__PURE__*/_react["default"].createElement(_Chip["default"], {
    avatar: "D",
    text: "Dok+",
    color: "blue"
  }), isCompanyActive('workflux') && /*#__PURE__*/_react["default"].createElement(_Chip["default"], {
    avatar: "W",
    text: "Workflux",
    color: "purple"
  }), isCompanyActive('indexia') && /*#__PURE__*/_react["default"].createElement(_Chip["default"], {
    avatar: "I",
    text: "Indexia",
    color: "red"
  }))), /*#__PURE__*/_react["default"].createElement("div", null, (user.groups || []).length > 0 && /*#__PURE__*/_react["default"].createElement("h3", null, "Grupos a que pertence"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "chips"
  }, userGroups.map(function (group) {
    return /*#__PURE__*/_react["default"].createElement(_Chip["default"], {
      key: group.uid,
      color: isActive ? 'white-green' : '',
      avatar: group.name[0],
      text: group.name
    });
  }))));
});
var _default = UserCard;
exports["default"] = _default;